import React, {useState, useEffect, useContext, useRef} from "react";


import {useHistory} from 'react-router-dom';
import {functions} from "../../constants/common-functions";
import {store} from '../../context/store';
import {NO_STRINGIFY} from "../../constants/general-constants";
import CircularProgress from '@material-ui/core/CircularProgress';
const DEFAULT_BLUE = "";

export default function AdministrationUploadBuildingPhotos(){
	const history = useHistory(); 
	const [displayProgress, setDisplayProgress] = useState("none");
	
	const uploadFileInput = useRef(null);
	
	const thisContainer = {
		display:"flex",
		width:"100%",
		height:"100%",
		backgroundColor:"white",
		flexDirection:"column"
	};
	
	const mainTitle = {
		display:"flex",
		marginLeft:"20px",
		height:"60px",
		fontSize:"21px",
		alignItems:"center"	
	};
	
	const description = {
		display:"flex",
		marginLeft:"20px",
		fontSize:"14px"
	};
	
	const descriptionRed = {
		display:"flex",
		marginLeft:"20px",
		fontSize:"21px",
		color:"red"
	};
	
	const fileInput = {
		display:"flex",
		margin:"20px"
	};
	
	const progressContainer = {
		display:displayProgress,
		width:"100%",
		height:"calc(100vh - 0px)",
		backgroundColor:"white",
		flexDirection:"column",
		zIndex:"2000",
		color:DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		position:"fixed",
		top:"0px",
		left:"0px"
	};
	
	const saveEnd = () => {
		alert("Upload Success");
		setDisplayProgress("none");
	};
	
	const handleSubmitError = () => {
		alert("Upload Success");
		setDisplayProgress("none");
	};
	
	const goUpload = () => {
		setDisplayProgress("flex");
		let formData = new FormData();
			formData.append("file", uploadFileInput.current.files[0]);
			
			functions.submitAjax("/resolution/uploadbuildingphotos", 
				formData, saveEnd, NO_STRINGIFY, handleSubmitError);
	};
	
	const editFooter = {
		display:"flex",
		height:"80px",
		width:"calc(100% - 60px)",
		position:"fixed",
		bottom:"0px",
		left:"60px",
		backgroundColor:"black",
		justifyContent:"space-around",
		alignItems:'center'
	};
	
	const editButtonContainer = {
		display:"flex"
	};
	
	const editButton = {
		display:"flex",
		width:"200px",
		height:"40px",
		borderRadius:"4px",
		alignItems:"center",
		color:'white',
		fontSize:"14px",
		justifyContent:"space-around",
		cursor:'pointer',
		border:"1px solid " +DEFAULT_BLUE,
		margin:"5px"
	};
	
	const goBack = () => {
		history.push('/voyansiadministrationhome');
	};
	
	return (
	
			<div style={thisContainer}>
					<div style={mainTitle}>
						Upload Building Photos
					</div>
					<div style={description}>
						Upload a zip file containing photos for the buildings in the system.  Please use the building codes as the directory names in your zip file.
					</div>
					<div style={descriptionRed}>
						**The zip file MUST be named: buildingphotos.zip
					</div>
					<input type="file" style={fileInput} ref={uploadFileInput}/>
					<div style={progressContainer}>
				<CircularProgress
						color="inherit"
					>
					</CircularProgress>
			</div>
			<div style={editFooter}>
				<div style={editButtonContainer}>
					<div style={editButton} onClick={goUpload}>
						Upload
					</div>
					<div style={editButton} onClick={goBack}>
						Back To Menu
					</div>
				</div>
			</div>
			</div>
			
		
	);
}